// Bilingual (Hindi + English) translation strings for AstroDev website.
// Follows the mobile app copy so both stay in sync.

export const translations = {
  hi: {
    // Nav / brand
    brandName: "ऐस्ट्रोदेव",
    brandDomain: "astrodev.me",
    navHome: "मुख्य पृष्ठ",
    navAbout: "मेरे बारे में",
    navPackages: "परामर्श शुल्क",
    navTestimonials: "अनुभव",
    navContact: "सम्पर्क",
    navAdmin: "एडमिन",
    bookNow: "परामर्श बुक करें",
    callNow: "अभी कॉल करें",

    // Hero
    heroBadge: "ॐ · JYOTISH ACHARYA · ॐ",
    astrologerName: "देवेन्द्र प्रकाश शर्मा",
    astrologerTitle: "पूर्व जिला एवं सत्र न्यायाधीश",
    tagline: "Justice से Jyotish तक",
    heroSub: "वैदिक ज्योतिष 95% भविष्यवाणी सटीकता के साथ",
    heroChip1: "95% भविष्यवाणी सटीकता",
    heroChip2: "साक्ष्य-आधारित विश्लेषण",
    expertiseTitle: "विशेषज्ञता के क्षेत्र",
    expertise: ["जैमिनी", "केपी सिस्टम", "CIL", "लाल किताब", "अष्टकवर्ग"],

    // About
    aboutTitle: "मेरे बारे में",
    aboutRole: "पूर्व जिला एवं सत्र न्यायाधीश | ज्योतिष शोधकर्ता",
    aboutP1:
      "मैं एक पूर्व जिला एवं सत्र न्यायाधीश हूँ तथा पिछले चार दशकों से अधिक समय से ज्योतिष के विभिन्न सिद्धांतों का अध्ययन, अनुसंधान एवं व्यावहारिक परीक्षण कर रहा हूँ। ज्योतिष के प्रति मेरी रुचि 19 वर्ष की आयु में प्रारम्भ हुई। इस क्षेत्र की प्रेरणा मुझे अपने पूज्य पितामह से मिली, जो एक प्रतिष्ठित ज्योतिषाचार्य थे तथा भारत की स्वतंत्रता से पूर्व पटियाला रियासत के राजगुरु रहे।",
    aboutP2:
      "न्यायिक सेवा में रहते हुए भी ज्योतिष मेरा सतत अध्ययन एवं शोध का विषय बना रहा। मैंने वैदिक ज्योतिष, के.पी. (KP), कस्पल इंटरलिंक थ्योरी (CIL), अष्टकवर्ग, जैमिनी, नाड़ी ज्योतिष तथा अन्य पारंपरिक प्रणालियों का गहन अध्ययन किया है।",
    aboutP3:
      "एक न्यायाधीश के रूप में मेरा विश्वास था कि प्रत्येक निर्णय साक्ष्यों और तर्क पर आधारित होना चाहिए। यही सिद्धांत मैं ज्योतिष में भी अपनाता हूँ। मेरा उद्देश्य केवल भविष्यवाणी करना नहीं, बल्कि लोगों को सही दिशा, स्पष्टता और आत्मविश्वास प्रदान करना है।",
    aboutP4:
      "सेवानिवृत्ति के पश्चात् मैंने स्वयं को पूर्णतः ज्योतिष सेवा के लिए समर्पित कर दिया। परामर्श से प्राप्त आय का एक महत्वपूर्ण भाग मैं आर्थिक रूप से कमजोर एवं जरूरतमंद व्यक्तियों की सहायता हेतु समर्पित करता हूँ।",
    aboutQuote: "ज्ञान का सर्वोच्च उद्देश्य मानवता की सेवा है।",

    // Packages
    packagesTitle: "परामर्श शुल्क",
    packagesSub: "बहुत ही उचित शुल्क — कोई भी सज्जन आसानी से ले सकते हैं।",
    bookPackage: "परामर्श बुक करें",

    // Testimonials
    testimonialsTitle: "श्रद्धालुओं के अनुभव",
    addExperience: "अपना अनुभव जोड़ें",
    testimonials: [
      {
        text: "गुरुजी ने मेरे नौकरी परिवर्तन की भविष्यवाणी छह महीने पहले, सटीक सप्ताह तक बता दी थी। उनकी साक्ष्य-आधारित पद्धति अद्वितीय है।",
        author: "— अनिल कुमार, जयपुर",
      },
      {
        text: "अत्यन्त विश्वसनीय एवं सटीक। गुरुजी ने मेरी पुत्री की कुंडली का अष्टकवर्ग एवं लाल किताब द्वारा विश्लेषण किया — परिणाम आश्चर्यजनक रूप से सटीक थे।",
        author: "— सुशीला देवी, दिल्ली",
      },
      {
        text: "एक पूर्व न्यायाधीश जो अब ग्रहों का न्याय करते हैं। हर भविष्यवाणी स्पष्ट ग्रह-साक्ष्य पर आधारित थी।",
        author: "— राजेश शर्मा, उदयपुर",
      },
    ],

    // Contact modes
    contactModesTitle: "परामर्श के तरीके",
    modeWaChat: "व्हाट्सएप चैट",
    modeWaVideo: "व्हाट्सएप वीडियो कॉल",
    modeWaVideoDesc: "व्हाट्सएप वीडियो कॉल पर आमने-सामने अपने प्रश्न पूछें।",
    modeVoice: "वॉयस कॉल",
    modeInPerson: "व्यक्तिगत मुलाकात",
    modeInPersonDesc:
      "पूर्व नियुक्ति लेकर गुरुजी के जयपुर कार्यालय में व्यक्तिगत रूप से मिलें।",
    officeTitle: "कार्यालय का पता",
    officeName: "देवेन्द्र प्रकाश शर्मा",
    directions: "रास्ता देखें",
    inPersonNote: "व्यक्तिगत भेंट के लिए कृपया पहले फ़ोन कर के समय तय करें।",
    openInMaps: "Google Maps में खोलें",

    // Contact block
    contactTitle: "सम्पर्क एवं जिज्ञासा",
    contactSub: "किसी भी नम्बर पर सम्पर्क कर के जानकारी व नियुक्ति ली जा सकती है।",
    whatsappVoice: "व्हाट्सएप / वॉयस कॉल",
    inquiryPayment: "जिज्ञासा / भुगतान",

    footerRights: "© 2026 देवेन्द्र प्रकाश शर्मा",

    // Booking form
    bookingTitle: "परामर्श बुकिंग",
    bookingSub: "कृपया विवरण भरें ताकि आपका सत्र निर्धारित किया जा सके।",
    selectedPackage: "चयनित सेवा",
    fullName: "पूरा नाम",
    gender: "लिंग",
    male: "पुरुष",
    female: "स्त्री",
    other: "अन्य",
    contactNumber: "सम्पर्क नम्बर (व्हाट्सएप)",
    email: "ईमेल (वैकल्पिक)",
    dob: "जन्म तिथि",
    tob: "जन्म समय",
    pob: "जन्म स्थान (नगर, राज्य)",
    questions: "अपने प्रश्न / चिंता (वैकल्पिक)",
    lifeEvents: "प्रमुख जीवन घटनाएँ (वैकल्पिक)",
    lifeEventsAdd: "घटना जोड़ें",
    lifeEventsEmpty: "अभी तक कोई घटना नहीं जोड़ी गई है — विवाह, शिक्षा, नौकरी, बीमारी, विदेश यात्रा आदि जोड़ सकते हैं।",
    lifeEventsPlaceholder: "घटना का विवरण (जैसे 'विवाह', 'नौकरी परिवर्तन')",
    firstChildDob: "प्रथम संतान की जन्म तिथि (लगभग) — वैकल्पिक",
    firstChildTob: "प्रथम संतान का जन्म समय (लगभग)",
    secondChildDob: "द्वितीय संतान की जन्म तिथि (लगभग) — वैकल्पिक",
    secondChildTob: "द्वितीय संतान का जन्म समय (लगभग)",
    proceedToPay: "भुगतान पर जाएँ",
    required: "आवश्यक",

    // Payment
    paymentTitle: "UPI भुगतान",
    paymentSub:
      "नीचे दिए UPI नम्बर पर भुगतान करें और भुगतान का स्क्रीनशॉट अपलोड करें।",
    upiNumber: "UPI नम्बर",
    upiName: "UPI नाम",
    amount: "राशि",
    txnRef: "UTR / लेन-देन संख्या",
    uploadScreenshot: "भुगतान स्क्रीनशॉट अपलोड करें",
    submitBooking: "बुकिंग जमा करें",
    submitting: "जमा हो रहा है...",
    payVia: "UPI ऐप में खोलें",

    // Success
    successTitle: "बुकिंग प्राप्त हुई",
    successMsg:
      "आपकी बुकिंग सफलतापूर्वक जमा हो गई है। हमारी टीम शीघ्र ही आपसे व्हाट्सएप पर सम्पर्क करेगी।",
    bookingId: "बुकिंग आईडी",
    backToHome: "मुख्य पृष्ठ पर जाएँ",

    // Admin
    adminLoginTitle: "एडमिन लॉगिन",
    adminPin: "एडमिन PIN",
    login: "लॉगिन",
    adminPanelTitle: "एडमिन पैनल",
    bookings: "बुकिंग्स",
    settings: "सेटिंग्स",
    logout: "लॉगआउट",
    noBookings: "कोई बुकिंग नहीं",
    markRead: "पढ़ा गया",
    unread: "नई",
    read: "पढ़ी गई",
    viewDetails: "विवरण देखें",
    save: "सेव करें",
    saved: "सेव हो गया",
    invalidPin: "गलत PIN",

    // Feedback
    feedbackName: "आपका नाम",
    feedbackCity: "शहर",
    feedbackText: "आपका अनुभव",
    submitFeedback: "अनुभव जमा करें",
    feedbackThanks: "धन्यवाद! आपका अनुभव भेज दिया गया है।",

    langLabel: "हिं",
  },

  en: {
    brandName: "AstroDev",
    brandDomain: "astrodev.me",
    navHome: "Home",
    navAbout: "About",
    navPackages: "Packages",
    navTestimonials: "Testimonials",
    navContact: "Contact",
    navAdmin: "Admin",
    bookNow: "Book Consultation",
    callNow: "Call Now",

    heroBadge: "ॐ · JYOTISH ACHARYA · ॐ",
    astrologerName: "Devender Parkash Sharma",
    astrologerTitle: "Former Principal District & Sessions Judge",
    tagline: "Justice से Jyotish तक",
    heroSub: "Vedic Astrology with 95% prediction accuracy",
    heroChip1: "95% prediction accuracy",
    heroChip2: "Evidence-based analysis",
    expertiseTitle: "Areas of Expertise",
    expertise: ["Jaimini", "KP System", "CIL", "Lal Kitab", "Ashtakvarga"],

    aboutTitle: "About Me",
    aboutRole: "Former Principal District & Sessions Judge | Astrology Researcher",
    aboutP1:
      "I am a Former Principal District & Sessions Judge and have been studying, researching and practising astrology for over four decades. My interest in astrology began at the age of 19, inspired by my revered grandfather, a distinguished astrologer and Rajguru of the Patiala state before India’s independence.",
    aboutP2:
      "Even during my judicial career, astrology remained a subject of continuous study and research. I have deeply studied Vedic Astrology, KP, Cuspal Interlink Theory (CIL), Ashtakvarga, Jaimini, Nadi astrology and other traditional systems.",
    aboutP3:
      "As a judge, I believed that every decision must be based on evidence and reasoning. I apply the same principle to astrology. My aim is not merely to predict, but to give people direction, clarity and confidence.",
    aboutP4:
      "After retirement, I have devoted myself completely to astrology service. A significant portion of the income from consultations is dedicated to helping the economically weak and needy.",
    aboutQuote: "The highest purpose of knowledge is the service of humanity.",

    packagesTitle: "Consultation Packages",
    packagesSub: "Fair, accessible pricing — designed so anyone in need can consult.",
    bookPackage: "Book Now",

    testimonialsTitle: "What Clients Say",
    addExperience: "Share your experience",
    testimonials: [
      {
        text:
          "Guruji predicted my job change six months in advance, accurate to the exact week. His evidence-based method is one of a kind.",
        author: "— Anil Kumar, Jaipur",
      },
      {
        text:
          "Extremely reliable and accurate. Guruji analysed my daughter's chart using Ashtakvarga and Lal Kitab — the results were astonishingly precise.",
        author: "— Sushila Devi, Delhi",
      },
      {
        text:
          "A former judge who now judges the planets. Every prediction was backed by clear planetary evidence.",
        author: "— Rajesh Sharma, Udaipur",
      },
    ],

    contactModesTitle: "Consultation Modes",
    modeWaChat: "WhatsApp Chat",
    modeWaVideo: "WhatsApp Video Call",
    modeWaVideoDesc: "Ask your questions face-to-face on a WhatsApp video call.",
    modeVoice: "Voice Call",
    modeInPerson: "In-Person Meeting",
    modeInPersonDesc:
      "Meet Guruji in person at his Jaipur office by prior appointment.",
    officeTitle: "Office Address",
    officeName: "Devender Parkash Sharma",
    directions: "Get Directions",
    inPersonNote: "For in-person meetings please call first to schedule a time.",
    openInMaps: "Open in Google Maps",

    contactTitle: "Contact & Inquiries",
    contactSub: "Reach any number below for information or to book an appointment.",
    whatsappVoice: "WhatsApp / Voice",
    inquiryPayment: "Inquiry / Payment",

    footerRights: "© 2026 Devender Parkash Sharma",

    bookingTitle: "Booking Details",
    bookingSub: "Please share your details so we can schedule your session.",
    selectedPackage: "Selected Package",
    fullName: "Full Name",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    contactNumber: "Contact Number (WhatsApp)",
    email: "Email (optional)",
    dob: "Date of Birth",
    tob: "Time of Birth",
    pob: "Place of Birth (city, state)",
    questions: "Your questions / concerns (optional)",
    lifeEvents: "Key life events (optional)",
    lifeEventsAdd: "Add event",
    lifeEventsEmpty: "No events added yet — feel free to add marriage, education, job change, illness, travel abroad etc.",
    lifeEventsPlaceholder: "Event description (e.g. 'Marriage', 'Job change')",
    lifeEventsTime: "Approx. time",
    firstChildDob: "First Child DOB (approx.) — optional",
    firstChildTob: "First Child Time (approx.)",
    secondChildDob: "Second Child DOB (approx.) — optional",
    secondChildTob: "Second Child Time (approx.)",
    proceedToPay: "Proceed to Payment",
    required: "Required",

    paymentTitle: "UPI Payment",
    paymentSub:
      "Pay to the UPI number below and upload the payment screenshot to confirm your booking.",
    upiNumber: "UPI Number",
    upiName: "UPI Name",
    amount: "Amount",
    txnRef: "UTR / Transaction Ref",
    uploadScreenshot: "Upload Payment Screenshot",
    submitBooking: "Submit Booking",
    submitting: "Submitting…",
    payVia: "Open in UPI App",

    successTitle: "Booking Received",
    successMsg:
      "Your booking has been submitted. Our team will contact you shortly on WhatsApp.",
    bookingId: "Booking ID",
    backToHome: "Back to Home",

    adminLoginTitle: "Admin Login",
    adminPin: "Admin PIN",
    login: "Login",
    adminPanelTitle: "Admin Panel",
    bookings: "Bookings",
    settings: "Settings",
    logout: "Logout",
    noBookings: "No bookings yet",
    markRead: "Mark Read",
    unread: "New",
    read: "Read",
    viewDetails: "View Details",
    save: "Save",
    saved: "Saved",
    invalidPin: "Invalid PIN",

    feedbackName: "Your Name",
    feedbackCity: "City",
    feedbackText: "Your experience",
    submitFeedback: "Submit",
    feedbackThanks: "Thank you! Your experience has been shared.",

    langLabel: "EN",
  },
};

export function pickLangText(pkg, lang, field) {
  // helper for package objects that come from backend with hi_/en_ prefixes
  const key = `${lang}_${field}`;
  return pkg[key] || pkg[`en_${field}`] || "";
}
